import { useEffect, useState } from 'react';

export const useWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  const comparison = width / height;
  const [windowDimensions, setWindowDimensions] = useState({
    width,
    height,
    comparison
  });

  useEffect(() => {
    function handleResize() {
      const { innerWidth: width, innerHeight: height } = window;
      const comparison = width / height;
      setWindowDimensions({ width, height, comparison });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
